import React from 'react'
import createRenderer from 'components/FormField'
import { FormLabel } from 'components'

const TextInput = createRenderer(
	(input, label, description, disabled = false, id, rest) => (
		<>
			{label && (
				<FormLabel
					htmlFor={id}
					text={label}
					description={description}
				/>
			)}
			<input
				type="text"
				id={id}
				className="c-form__input"
				disabled={disabled}
				{...input}
				{...rest}
			/>
		</>
	)
)

export default TextInput
